import { useContext } from "react";
import { ApiContext } from "../contexts/ApiContext";
import { useMutation } from "react-query";
import { QueryCallbacks } from "../shared/interfaces/ReactQuery";

export function useWorkflowDelete(callbacks?: QueryCallbacks<null>) {
  const apiContext = useContext(ApiContext);
  return useMutation(
    ["deleteWorkflow"],
    async (workflowId: number) => apiContext.workflowApis.deleteWorkflow(workflowId),
    {
      onSuccess: callbacks?.onSuccess,
      onError: callbacks?.onError,
    },
  );
}
